import React, { Fragment } from 'react';
import SliderWrapper from 'js/components/global/SliderWrapper';
import SliderArrow from 'js/components/global/SliderArrow';
import { VacationContext } from './VacationContext';
import { questionToNaturalLanguage } from 'js/modules/utils';

const ResortCard = (props) => {
  const resortName = props.resort.resortName;
  const resortRegion = props.resort.resortRegion;
  const questions = props.questions;
  const resortImages = props.images ? props.images : [];
  const sliderSettings = {
    arrows: true,
    dots: true,
    dotPositionInside: false,
    infinite: true,
    nextArrow: <SliderArrow icon="icon-next" />,
    prevArrow: <SliderArrow icon="icon-prev" />,
  };

  const selectResort = (context) => {
    context.toggleCollapsible({ 'showResorts': !context.state.showResorts });
    context.setInputValue(props.resort.value, 'rstCode');
  };

  return (
    <VacationContext.Consumer>
      {
        (context) => {
          return (
            <div className="resort-card">
              <div className="resort-images">
                {
                  resortImages.length > 0 &&
                <SliderWrapper {...sliderSettings}>
                  {
                    resortImages.map((image, index) => (
                      <img key={'img-rst-' + index} className="util-img-responsive" src={image.source} alt={image.title} />
                    ))
                  }
                </SliderWrapper>
                }
              </div>

              <div className="resort-details">
                <div className="resort-details-left">
                  <div className="resort-title">
                    <h1 className="resort-name">{resortName}</h1>
                    <h2 className="resort-region">{resortRegion}</h2>
                  </div>
                  <h3 className="resort-questions">
                    {
                      questions.map((question, index) => {
                        return (
                          <span>
                            <Fragment>{index > 0 ? ' \u2022 ' : ''} {questionToNaturalLanguage(question)}</Fragment>
                          </span>
                        );
                      })
                    }
                  </h3>
                </div>
                <div className="resort-details-right">
                  <div className="btn-section">
                    <button onClick={() => selectResort(context)} className="btn-primary">Select Resort</button>
                  </div>
                </div>
              </div>
            </div >
          );
        }
      }
    </VacationContext.Consumer>
  );
};

export default ResortCard;



// WEBPACK FOOTER //
// ./js/components/step1/ResortCard.js